// Getters
export const dailyTasks = (state) => {
  return state.dailyTasks.data || []
}
export const dailyTasksLoading = (state) => {
  return state.dailyTasks.loading
}
export const dailyTasksLastUpdate = (state) => {
  return state.dailyTasks.lastUpdate
}

export const professional = (state) => {
  return state.professional.data || []
}
export const professionalLoading = (state) => {
  return state.professional.loading
}
export const professionalLastUpdate = (state) => {
  return state.professional.lastUpdate
}

export const clients = (state) => {
  return state.clients.data || []
}
export const clientsLoading = (state) => {
  return state.clients.loading
}
export const clientsLastUpdate = (state) => {
  return state.clients.lastUpdate
}

export const showModalAssign = (state) => {
  return state.showModalAssign
}

export const idModalAssign = (state) => {
  return state.idModalAssign
}

export const modalInfoAlert = (state) => {
  return state.modalInfoAlert
}

export const importData = (state) => {
  return state.import.data || []
}
export const importLoading = (state) => {
  return state.import.loading
}
export const importLastUpdate = (state) => {
  return state.import.lastUpdate
}

export const exportData = (state) => {
  return state.export.data || []
}
export const exportLoading = (state) => {
  return state.export.loading
}
export const exportLastUpdate = (state) => {
  return state.export.lastUpdate
}

export const tasksSelected = (state) => {
  return state.clients.selected || []
}
